export default __webpack_public_path__ + "72d926dd6f8d781582ee2b7ad8af8a3b.mp3";